import { createContext, useContext } from 'react';
import type { ApiClient } from '../lib/api';

export interface Me {
  email: string;
  role: 'viewer' | 'editor';
}

export const ApiContext = createContext<ApiClient | null>(null);

export function useApi(): ApiClient {
  const api = useContext(ApiContext);
  if (!api) throw new Error('ApiContext가 없습니다.');
  return api;
}
